import { render, staticRenderFns } from "./RealTimeVideoFlv.vue?vue&type=template&id=6149bc5e&scoped=true"
import script from "./RealTimeVideoFlv.vue?vue&type=script&lang=js"
export * from "./RealTimeVideoFlv.vue?vue&type=script&lang=js"
import style0 from "./RealTimeVideoFlv.vue?vue&type=style&index=0&id=6149bc5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6149bc5e",
  null
  
)

export default component.exports